import React from 'react';

const Career = () => {
  return (
    <>
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
        Career Opportunities at <span className="text-primary-700">BildUp</span>
      </h1>

      <div className="grid md:grid-cols-2 gap-8 mb-16">
        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow hover:border-primary-300 transition-colors">
          <h2 className="text-2xl font-bold text-primary-700 mb-4">
            Why Join BildUp?
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Work with cutting-edge AI technology</li>
            <li>Flexible remote work options</li>
            <li>Competitive compensation package</li>
            <li>Professional development opportunities</li>
            <li>Inclusive and innovative work culture</li>
          </ul>
        </div>

        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow hover:border-primary-300 transition-colors">
          <h2 className="text-2xl font-bold text-primary-700 mb-4">
            Our Values
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Innovation in education</li>
            <li>Student success first</li>
            <li>Continuous learning</li>
            <li>Diversity and inclusion</li>
            <li>Data-driven decisions</li>
          </ul>
        </div>
      </div>

      <div className="p-6 bg-white border border-gray-200 rounded-lg shadow mb-16 hover:border-primary-300 transition-colors">
        <h2 className="text-2xl font-bold text-primary-700 mb-4">
          Open Positions
        </h2>
        <ol className="relative border-l border-primary-200">
          <li className="mb-10 ml-6">
            <span className="absolute flex items-center justify-center w-6 h-6 bg-primary-100 rounded-full -left-3 ring-8 ring-white">
              <svg className="w-3 h-3 text-primary-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
              </svg>
            </span>
            <h3 className="font-medium leading-tight text-primary-700">Senior Full Stack Developer</h3>
            <p className="text-gray-700">Join our engineering team to build the future of education technology.</p>
          </li>
          <li className="mb-10 ml-6">
            <span className="absolute flex items-center justify-center w-6 h-6 bg-primary-100 rounded-full -left-3 ring-8 ring-white">
              <svg className="w-3 h-3 text-primary-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
              </svg>
            </span>
            <h3 className="font-medium leading-tight text-primary-700">AI/ML Engineer</h3>
            <p className="text-gray-700">Help develop our AI-powered learning algorithms and personalization features.</p>
          </li>
          <li className="ml-6">
            <span className="absolute flex items-center justify-center w-6 h-6 bg-primary-100 rounded-full -left-3 ring-8 ring-white">
              <svg className="w-3 h-3 text-primary-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
              </svg>
            </span>
            <h3 className="font-medium leading-tight text-primary-700">Product Manager</h3>
            <p className="text-gray-700">Lead product strategy and development for our educational platform.</p>
          </li>
        </ol>
      </div>
    </>
  );
};

export default Career; 